var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IngenieriaItem',{key:"hidraulicas",staticClass:"content",attrs:{"index":2,"source":_vm.frame,"folder":"backgrounds","texto":_vm.texto}})
}
var staticRenderFns = []

export { render, staticRenderFns }